const CAP12 = {
  "id": 33,
  "title": "Ventajas de Bitcoin",
  "subtitle": "Curso Bitcoin 101",
  "sections": [
    {
      "heading": "¿Por qué se habla tanto de Bitcoin?",
      "text": [
        "Cada vez escuchamos más sobre Bitcoin y las criptomonedas en general. Una de las razones principales es que reúnen una serie de características que las hacen muy diferentes al dinero tradicional.",
        "En esta lección veremos las ventajas más importantes de Bitcoin como sistema monetario digital, descentralizado y global."
      ]
    },
    {
      "heading": "1. Emisión descentralizada",
      "text": [
        "Ningún gobierno, banco central ni empresa puede controlar de forma unilateral la creación ni la distribución de bitcoin.",
        "Con Bitcoin, la política monetaria está definida en el propio protocolo y es conocida por todos. Esto ayuda a “despolitizar” el dinero: no depende de decisiones de unos pocos, sino de un conjunto de reglas transparentes que se aplican por igual para toda la red.",
        "De esta forma se reduce el control que el dinero fiduciario tradicional permite ejercer sobre la población a través de la emisión y manipulación de la oferta monetaria."
      ]
    },
    {
      "heading": "2. Transparencia en las transacciones",
      "text": [
        "Todas las transacciones de Bitcoin se registran en un libro contable público llamado blockchain.",
        "Aunque las direcciones funcionan como seudónimos y no aparecen nombres reales, cualquier persona puede ver en tiempo real:",
        "• Qué dirección envía fondos.",
        "• Qué dirección los recibe.",
        "• Cuánto se envía y en qué momento ocurrió.",
        "Esta transparencia permite, por ejemplo, que organizaciones como ONG, fundaciones o entidades públicas puedan mostrar de manera verificable cómo utilizan los fondos que reciben."
      ]
    },
    {
      "heading": "3. Emisión limitada",
      "text": [
        "El número máximo de bitcoin que podrán existir está fijado en el protocolo: nunca habrá más de 21 millones.",
        "Nadie puede “imprimir” nuevos bitcoin de la nada porque le resulte conveniente. Todos los nuevos BTC se crean a través del proceso de minería, siguiendo reglas matemáticas públicas y predecibles.",
        "Esto contrasta con las monedas fiduciarias, donde la oferta puede ampliarse de forma discrecional, generando inflación y pérdida de poder adquisitivo con el tiempo."
      ]
    },
    {
      "heading": "4. Sin barreras ni permisos",
      "text": [
        "Con Bitcoin, tú mismo puedes ser tu propio banco. No necesitas pedir permiso para abrir una cuenta, ni firmar contratos, ni pagar comisiones de mantenimiento.",
        "Crear un monedero (wallet) es gratuito y no tiene límite de saldo. Desde él puedes enviar y recibir bitcoin a cualquier parte del mundo sin que nadie pueda bloquear tus movimientos.",
        "No hay condiciones ocultas, ni suscripciones forzosas, ni compromisos de permanencia. Lo único que necesitas es conexión a Internet y una cartera compatible."
      ]
    },
    {
      "heading": "5. Mayor grado de privacidad",
      "text": [
        "Vivimos en una época de robo de datos, filtraciones masivas y análisis de grandes volúmenes de información (Big Data). Proteger la privacidad financiera es cada vez más importante.",
        "Bitcoin no es completamente anónimo, sino seudónimo: las transacciones están ligadas a direcciones, no a nombres. Esto ofrece un mayor grado de confidencialidad que muchos métodos de pago tradicionales.",
        "Usado correctamente y con buenas prácticas, Bitcoin puede ayudar a reducir la exposición innecesaria de información financiera sensible."
      ]
    },
    {
      "heading": "6. Alcance global",
      "text": [
        "Bitcoin es una red sin fronteras, similar a Internet o al correo electrónico.",
        "Puedes enviar valor a cualquier país del mundo sin tener que preocuparte por bancos corresponsales, restricciones horarias, días festivos o diferencias de infraestructura financiera.",
        "Es la primera forma de dinero verdaderamente global que funciona de manera nativa en la red."
      ]
    },
    {
      "heading": "7. Velocidad en los envíos",
      "text": [
        "Una transacción de Bitcoin puede propagarse a la red prácticamente al instante y recibir sus primeras confirmaciones en cuestión de minutos.",
        "La cantidad enviada no afecta al tiempo de propagación: enviar el equivalente a unos pocos euros o una suma mucho mayor toma el mismo tiempo de verificación en la red.",
        "Comparado con transferencias internacionales tradicionales, que pueden tardar días, el funcionamiento de Bitcoin resulta mucho más ágil."
      ]
    },
    {
      "heading": "8. Costes de uso reducidos",
      "text": [
        "Enviar dinero al extranjero a través de bancos o intermediarios suele implicar comisiones elevadas y tipos de cambio poco favorables.",
        "Con Bitcoin, las comisiones suelen ser bajas en comparación, especialmente para pagos internacionales, y en algunos momentos de baja congestión pueden ser muy pequeñas.",
        "Además, Bitcoin permite realizar micropagos, como enviar unos céntimos a otra persona en agradecimiento por un contenido o servicio, algo que con la banca tradicional es prácticamente inviable por las comisiones mínimas."
      ]
    },
    {
      "heading": "9. Propiedad total de tus fondos",
      "text": [
        "Si controlas tus claves privadas, los bitcoin que gestionas son completamente tuyos.",
        "Ningún banco, gobierno u otra entidad puede confiscar, congelar o impedir que uses tus fondos, siempre que mantengas el control de tu monedero.",
        "Esto hace que fenómenos como los “corralitos” bancarios o los bloqueos unilaterales de cuentas sean imposibles a nivel de protocolo en Bitcoin."
      ]
    },
    {
      "heading": "10. Dinero programable",
      "text": [
        "Bitcoin incluye un lenguaje de scripting que permite añadir cierta lógica a las transacciones, haciendo que el dinero sea, en cierto modo, programable.",
        "Esto abre la puerta a casos de uso como:",
        "• Pagos condicionados.",
        "• Sistemas de depósito en garantía (escrow).",
        "• Automatización de cobros entre servicios o dispositivos.",
        "Gracias a esta característica, desarrolladores de todo el mundo pueden integrar Bitcoin en aplicaciones y servicios sin necesidad de pedir permisos a ningún intermediario."
      ]
    },
    {
      "heading": "11. Seguridad criptográfica y red distribuida",
      "text": [
        "Bitcoin se apoya en uno de los sistemas criptográficos más robustos que existen hoy en día, utilizado en cada paso del proceso: generación de claves, firmas digitales y prueba de trabajo.",
        "Su carácter distribuido —con miles de nodos repartidos por el mundo— hace que la red sea extremadamente resistente a fallos, ataques y caídas localizadas.",
        "Desde su lanzamiento en 2009, la red de Bitcoin ha estado operativa sin interrupción significativa, procesando transacciones todos los días del año."
      ]
    },
    {
      "heading": "12. Transparencia reforzada",
      "text": [
        "Además de ser pública, la cadena de bloques es inmutable: los registros históricos no se pueden alterar sin que toda la red lo detecte.",
        "Esto permite auditorías completas: cualquier persona puede revisar el historial de transacciones de una dirección que se haya hecho pública, lo que la convierte en una herramienta útil para entidades que quieren demostrar el uso responsable de sus fondos.",
        "Gobiernos, organizaciones sin ánimo de lucro, proyectos comunitarios o empresas pueden aprovechar esta transparencia para generar mayor confianza."
      ]
    },
    {
      "heading": "13. Código abierto y comunidad global",
      "text": [
        "El software de Bitcoin es completamente de código abierto y puede ser revisado, estudiado y mejorado por cualquiera.",
        "Desarrolladores de todo el mundo colaboran de forma continua para mantener y optimizar el protocolo, revisar propuestas de cambio y reforzar la seguridad.",
        "Cualquier persona puede crear su propia implementación del software o incluso usar el código como base para experimentar con nuevas ideas, lo que ha dado lugar a multitud de proyectos relacionados."
      ]
    },
    {
      "heading": "14. Sistema basado en consenso",
      "text": [
        "En Bitcoin, las decisiones importantes no las toma una sola entidad, sino que requieren consenso entre la comunidad técnica, los nodos, los mineros y los usuarios.",
        "Las actualizaciones del protocolo solo se aplican cuando una mayoría significativa las considera beneficiosas y decide adoptarlas.",
        "Del mismo modo, las transacciones se consideran válidas solo cuando la mayoría de los nodos siguen las mismas reglas y aceptan incluirlas en la cadena. Este modelo basado en consenso es una de las bases de la solidez y la resiliencia de Bitcoin."
      ]
    }
  ]
}


export default CAP12;
